import { Switch, SwitchOnChangeData, Text } from "@fluentui/react-components";
import { Flex } from "components/styled";
import { inContextEditorPostProcessor } from "i18n";
import { useAtom } from "jotai";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { phraseToolActivatedAtom } from "store";

export function InlinePhraseToggle() {
  const { search, pathname } = useLocation();
  const [phraseActive, setPhraseActive] = useAtom(phraseToolActivatedAtom);
  const navigate = useNavigate();

  const phraseEnabled =
    !!new URLSearchParams(search).get("phrase_context") ||
    inContextEditorPostProcessor.phraseEnabled;

  useEffect(() => {
    setPhraseActive(phraseEnabled);
  }, [phraseEnabled]);

  return (
    <Flex width={"100%"} justify="space-between">
      <Text>{"Inline Phrase Tool"}</Text>

      <Switch
        title="Phrase"
        defaultChecked={phraseActive}
        onChange={(_, data: SwitchOnChangeData) => {
          const checked = data.checked;
          if (checked) {
            setPhraseActive(true);
            inContextEditorPostProcessor.phraseEnabled = true;
          } else {
            setPhraseActive(false);

            inContextEditorPostProcessor.phraseEnabled = false;
            const queryParams = new URLSearchParams(search);
            if (queryParams.get("phrase_context")) {
              queryParams.delete("phrase_context");
              navigate({
                pathname: pathname,
                search: queryParams.toString(),
              });
            }
            // Reload is needed because we have to remove
            // Phrase scripts from the client
            window.location.reload();
          }
        }}
        indicator={{
          style: {
            margin: 0,
          },
        }}
      ></Switch>
    </Flex>
  );
}
